import { FlagAmountAxis, FlagPriority } from '@generated/graphql';

const FLAG_PRIORITY_SORT_RANK: Record<FlagPriority, number> = {
  [FlagPriority.Critical]: 0,
  [FlagPriority.High]: 1,
  [FlagPriority.Medium]: 2,
  [FlagPriority.Low]: 3,
  [FlagPriority.Unknown]: 4,
};

export const getFlagPrioritySortRank = (priority: FlagPriority): number =>
  FLAG_PRIORITY_SORT_RANK[priority] ??
  FLAG_PRIORITY_SORT_RANK[FlagPriority.Unknown];

type GlossaryPolicyValues = {
  thresholdCents?: number | null;
  percentThreshold?: number | null;
};

/** Numeric value for threshold column sorting; `-1` when not thresholdable or unset. */
export const getGlossaryThresholdSortValue = (
  values: GlossaryPolicyValues,
  axis: FlagAmountAxis | null | undefined,
  isAmountThresholdable: boolean,
): number => {
  if (!isAmountThresholdable) {
    return -1;
  }
  if (axis === FlagAmountAxis.Cents && values.thresholdCents != null) {
    return values.thresholdCents;
  }
  if (axis === FlagAmountAxis.PercentOnly && values.percentThreshold != null) {
    return values.percentThreshold;
  }
  return -1;
};

export const FLAG_GLOSSARY_SORTABLE_COLUMN_IDS = [
  'flagName',
  'actualPriority',
  'actualThreshold',
  'defaultPriority',
  'defaultThreshold',
] as const;

export type FlagGlossarySortableColumnId =
  (typeof FLAG_GLOSSARY_SORTABLE_COLUMN_IDS)[number];
